/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./file-list-item.vue?vue&type=template&id=0cf83a75&scoped=true&"
import script from "./file-list-item.vue?vue&type=script&lang=ts&"
export * from "./file-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./file-list-item.vue?vue&type=style&index=0&id=0cf83a75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf83a75",
  null
  
)

export default component.exports